export const Guidelines = () => {
    return (
        <section>
        <h1>Guidelines goes here</h1>
        </section>
    )
}

